export function chooseRandomColor() {
	// Definir un arreglo de colores posibles
	const colores = ["magenta", "volcano", "orange", "gold", "green", "cyan", "blue", "geekblue", "purple"];
  
	// Elegir un índice aleatorio basado en la longitud del arreglo de colores
	const indiceAleatorio = Math.floor(Math.random() * colores.length);
  
	return colores[indiceAleatorio];
}